/**
 * Automatically poll the window or a turbo frame
 *
 * Use `data-turbo-poll` with the reload time in ms on an element to enable this.
 * This attr can be used for turbo and in-frame navigations
 */
export function enableTurboPolling() {
  function poll(el = document) {
    el.querySelectorAll("[data-turbo-poll]").forEach((el) => {
      const response = el.getAttribute("data-turbo-poll");
      const shouldPoll = response !== "false";

      if (!shouldPoll) return;

      const timeout = setTimeout(() => el.click(), response);
      document.addEventListener(
        "turbo:before-visit",
        () => clearTimeout(timeout),
        { once: true },
      );
    });
  }

  document.addEventListener("turbo:load", () => poll());
  document.addEventListener("turbo:frame-load", ({ target }) => poll(target));
}
